import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Fetches report data for a given mobile number using the centralized API call utility.
 *
 * @param {string} mobileNumber - The mobile number of the person you want to get data of.
 * @returns {Promise<Object>} - The report data for the specified date range.
 * @throws Will throw an error if the request fails or the dates are invalid.
 * @author Susovan Mishra
 */
const fetchCustomerReport = async (mobileNumber) => {
  const query = `mobileNumber=${encodeURIComponent(mobileNumber)}`;
  return await apiCall(`${AUTH_ROUTES.CUSTOMER_REPORT_API_ENDPOINT}?${query}`, {
    method: "GET",
  });
};

export default fetchCustomerReport;
